// Piccolo helper per distinguere la shell Cordova dalla PWA/web.
// Su browser normale `window.cordova` non esiste: se invochiamo i plugin xe casin.
export const isCordovaAvailable = (): boolean =>
  typeof window !== "undefined" && Boolean((window as any).cordova)
